export const IMPERSONATE_RETURN_URL_COOKIE = 'impersonateReturnUrl';
export const IMPERSONATE_USER_ID_COOKIE = 'impersonatedUserId';
export const STUDENT_DETAIL_REFERRER_COOKIE = 'studentDetailReferrer';

export const COOKIES_SETTINGS = {
  domain: import.meta.env.VITE_COOKIE_DOMAIN,
  path: '/'
};
